import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/165188d6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Column = makeShortcode("Column");
const Row = makeShortcode("Row");
const DoDontExample = makeShortcode("DoDontExample");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`A card is a flexible container that groups related blocks of content and information into a single unit.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">General guidance</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Anatomy</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Variations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Best practices</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1120px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.39285714285714%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsSAAALEgHS3X78AAAA00lEQVQoz92Quw6CMBSGeVcnN0kkgYCbYZPFB3DzBdxl9z1cuJVbSy1tj4eb0UBMXP2G5s855+vNAABKaRzHSU/cgyGKIgzZBCEkTVOskyzJkogUuVLKQDkMQ9M0HcexJzBbluV5XhAEhx4Mvu+7rruxdqv11t0f87zoZM75vQe3LyeqqpxD8uJ0ZfaZX24UQHayEKKua1zVG/ShGJdN0+CjXkWttZS6lVqIdrx223YJPtEAOIwtFGDGoIwnL05gG4dgiX+QGWPNEl/qo9z97Y8M1hMe4Wp9kxKcSAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of an empty card",
        "title": "Example of an empty card",
        "src": "/static/f0fdb9390be8985d77c6fe6914d74499/026f9/cards-hero.png",
        "srcSet": ["/static/f0fdb9390be8985d77c6fe6914d74499/d6747/cards-hero.png 288w", "/static/f0fdb9390be8985d77c6fe6914d74499/09548/cards-hero.png 576w", "/static/f0fdb9390be8985d77c6fe6914d74499/026f9/cards-hero.png 1120w"],
        "sizes": "(max-width: 1120px) 100vw, 1120px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an empty card</Caption>
    <h2 {...{
      "id": "general-guidance"
    }}>{`General guidance`}</h2>
    <p>{`Cards display a snapshot of information intended to encourage users to interact with or click to view more details or actions. According to the `}<a parentName="p" {...{
        "href": "https://www.nngroup.com/articles/cards-component/"
      }}>{`Nielsen Norman group`}</a>{`, cards have four key properties:`}</p>
    <ol>
      <li parentName="ol">{`Cards are used for grouping information and content.`}</li>
      <li parentName="ol">{`Cards present a summary and link to additional details.`}</li>
      <li parentName="ol">{`Cards resemble physical cards.`}</li>
      <li parentName="ol">{`Cards allow for a flexible layout.`}</li>
    </ol>
    <p>{`Editable cards group information that represents an object, object groupings, or a specific aspect of an object that the user can manage. Their primary purpose is for viewing and modifying content that is contained entirely in the card.`}</p>
    <p>{`Content cards are intended for grouping and organizing related static content. Their primary purpose is for displaying a summary of information and do not contain an editable state.`}</p>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <p>{`A card is composed of two distinct zones: the title and the body.`}</p>
    <h4 {...{
      "id": "title"
    }}>{`Title`}</h4>
    <p>{`The title of your card should mirror the content or summary in your card. You can also include an optional label, pictogram, or image above your header text. `}<strong parentName="p">{`Use sentence case for titles`}</strong>{`.`}</p>
    <h4 {...{
      "id": "body"
    }}>{`Body`}</h4>
    <p>{`Depending on the type and size of card you use, aim to use minimal body content in your card. Remember, cards present a summary or snapshot of information. You can place other components inside the body of card such as structured lists, data visualizations, images, links, videos, buttons, etc. These components will occupy the full width of the card.`}</p>
    <Column colMd={8} noGutterSm mdxType="Column">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "736px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.54347826086957%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAqUlEQVQoz6WR2w6DIAxA/f/PFMUpmDkuRaDCmGaZDHnZTpqUJj0tgSb+QXOkEKK1DsCgx6OshV9jwFzeMLCJDfQGALscLlchbvr+8r83K6WklEKIZVnSATToU+xlSquD8tpbGMeRENK/6Qpa0nLGnanIqaOvQzrCOXc6dRfyNDFK6XCC5qTR8zybR0RfyEoqkaNzlFbGrFZffZV36J3/hMfytVMb2kL+jSdw9kUL6RRvQQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "The anatomy of a card contains a title and the body.",
          "title": "The anatomy of a card contains a title and the body.",
          "src": "/static/6687fc336b7865d23b0787065034f744/ddf7f/card-anatomy.png",
          "srcSet": ["/static/6687fc336b7865d23b0787065034f744/d6747/card-anatomy.png 288w", "/static/6687fc336b7865d23b0787065034f744/09548/card-anatomy.png 576w", "/static/6687fc336b7865d23b0787065034f744/ddf7f/card-anatomy.png 736w"],
          "sizes": "(max-width: 736px) 100vw, 736px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </Column>
    <Row mdxType="Row">
  <Column colLg="4" colMd="4" mdxType="Column">
  <DoDontExample type="do" aspectRatio="2:2" color="light" text="Card titles can wrap up to 2 lines" mdxType="DoDontExample" />
      </Column>
      <Column colLg="4" colMd="4" mdxType="Column">
        <DoDontExample type="dont" aspectRatio="2:2" color="light" text="Scrolling is not allowed in the body of a card." mdxType="DoDontExample" />
  </Column>
    </Row>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <h3 {...{
      "id": "editable-cards"
    }}>{`Editable cards`}</h3>
    <p>{`Editable cards allow a user to view, modify, and save the content contained within the card. Use editable cards when a user needs to make changes to resources like configuration details or an account plan.`}</p>
    <br />
    <Row mdxType="Row">
  <Column colMd={8} noGutterSm mdxType="Column">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Types of editable cards`}</th>
              <th parentName="tr" {...{
                "align": null
              }}></th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`List views`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A structured list is used to show the details, attributes, or metadata of an object. A user can individually edit one line in the list or multiple.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Summary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Summary cards provide a brief overview of the state of an object (e.g. health status, speed, creation date, etc.) and can use multiple components.`}</td>
            </tr>
          </tbody>
        </table>
 </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1120px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.875%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQoz52Ru07DQBBF88eREAX8BF0UIeiChISgQBR0EEC08BUoRLEdO157X/Pg7hpDaLmaYmY1587s7kRVm6Zp29YY45yTJHaBW8uR6OLVH1z66aKdLszRDSOOr/nwis+fSEQngEECQ+KzMq/ECpe7t/7k3p696HzJsweeL+X0WWePevvOwpLgsiyHmViBiHQULHy/lWhyhXPRXzH6E7zZbIqiQFFVVQhhrwO+1cfqk0WNDT4SEmZwmlIeYVwYyXZbW2uHK4xwWdc1EudCiBGvIHk88wiv1+vOdNiqqgumtM8PDN8mw8aZveM9eHgwVNZ36JBR6Njt2s70MOydZVImScGCHb7h/DYyDJS/oqjkNTiJOZBwhGsKHb7q3/oCdHsFkjJQyBcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cards in a page layout",
            "title": "Cards in a page layout",
            "src": "/static/19502f2ceca9b47f769a620047c88abf/026f9/editable-cards.png",
            "srcSet": ["/static/19502f2ceca9b47f769a620047c88abf/d6747/editable-cards.png 288w", "/static/19502f2ceca9b47f769a620047c88abf/09548/editable-cards.png 576w", "/static/19502f2ceca9b47f769a620047c88abf/026f9/editable-cards.png 1120w"],
            "sizes": "(max-width: 1120px) 100vw, 1120px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Cards in a page layout</Caption>
      </Column>
    </Row>
    <p>{`Alert the user of any unsaved changes if they try to navigate to a different page while in the edit state.`}</p>
    <h3 {...{
      "id": "content-cards"
    }}>{`Content cards`}</h3>
    <p>{`Content cards group related information in a single location on the page. Content cards often include paragraphs and images or videos and accompanying text. These cards can be used in a variety of ways.`}</p>
    <p><strong parentName="p">{`1. Marketing, promotions, or introductions.`}</strong>{` These are small cards used to show a product summary or functionality for the user to learn about and try. It can be used to promote other supplementary such as docs and FAQs.`}</p>
    <p><strong parentName="p">{`2. Expandable on-boarding, learning material, or additional information.`}</strong>{` Use cards to give a user a glimpse into a feature, or use them to preview a learning resource like best practices or other types of educational content.`}</p>
    <Row mdxType="Row">
      <Column colMd={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "76.90217391304348%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsSAAALEgHS3X78AAABpUlEQVQoz41TS27bMBA1kNPkBL2H9z1GgG677hkCZJcU3vYA3RTwqkCXBQIE8K+SJZs/k+KIpNinYeofCiRPI2okzdO8maEmmRFTCvGEYRjyOzDBmYbBO5O90UYrrY0xfd/jOT6RLhHZgBMZYWtJ319cTBHhTdMIIbDiK1f8YQyIIYQi7ZU8fbA3X7bT+eLnTsi2rbfbqqrattVaK6WEkFg9BeWzobHGExne/dx9notPv5Y/FpucEvUjPKNjwCGijnpPPY7zzNkSmY7gkPcHBshnHRylArjC8OqC/PGrv32sZ3/afdtWVQ3NEOwYCD0WWZDOZUP43bfqw+z30/MiEG2bRkoJkdZakIt4YpQ+X5EzIs3hAAdxy+VytVrVdY2eIz8yj9Uy/kOGF/npwOT1er3ZbEBGfsXAzErnDtaW4V2SY0x8XzIjJzRr3jBlBRP5C+eafNw06OjYpbFY1/1D8dE3ihl2TfbE8ws9MgmxlwrbQgoGxgYVSIvitSUYhn5B1sLJnYWpvYOvdtaoMilXem4ZnRsNt2fdHnIKbD1byBFrfPuv+gvBbmDx78iSOgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Use cards for moments of learning",
            "title": "Use cards for moments of learning",
            "src": "/static/9211d129bc0ffbd40f1f08ec96b4349e/ddf7f/learning-example.png",
            "srcSet": ["/static/9211d129bc0ffbd40f1f08ec96b4349e/d6747/learning-example.png 288w", "/static/9211d129bc0ffbd40f1f08ec96b4349e/09548/learning-example.png 576w", "/static/9211d129bc0ffbd40f1f08ec96b4349e/ddf7f/learning-example.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a card used to educate a user on the next steps for provisioning
        </Caption>
      </Column>
    </Row>
    <p><strong parentName="p">{`3. Guide a user’s first steps`}</strong></p>
    <p>{`Content cards can invite the user to start a specific process such as getting started with a new offering, launching a starter kit, or deploying a resource.`}</p>
    <p><strong parentName="p">{`4. Group blocks of related content`}</strong></p>
    <p>{`Cards can be used to block groups of related content even if it doesn’t fit into the above models.`}</p>
    <h2 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h2>
    <h4 {...{
      "id": "do"
    }}>{`Do`}</h4>
    <ul>
      <li parentName="ul">{`Intentionally organize cards within the page layout by grouping related cards in sections`}</li>
      <li parentName="ul">{`Consider adding page filters if you have a large collection of cards (e.g. Catalog page)`}</li>
      <li parentName="ul">{`Use `}<a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/structured-list/code"
        }}>{`structured lists`}</a>{` instead of tables`}</li>
      <li parentName="ul">{`Use editable cards to show areas of the page the user can edit`}</li>
    </ul>
    <h4 {...{
      "id": "dont"
    }}>{`Don’t`}</h4>
    <ul>
      <li parentName="ul">{`Nest a card within another element such as a table`}</li>
      <li parentName="ul">{`Do not use editable cards for complex multi-step flows. Consider using a `}<a parentName="li" {...{
          "href": "https://pages.github.ibm.com/ibmcloud/cloud-ux-patterns/Views/SidePanel/usage/"
        }}>{`side panel`}</a>{` instead.`}</li>
      <li parentName="ul">{`Do not use cards in modals`}</li>
      <li parentName="ul">{`Avoid using tables. Use a `}<a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/structured-list/code"
        }}>{`structured list`}</a>{` instead.`}</li>
      <li parentName="ul">{`Avoid scrolling`}</li>
    </ul>
    <h3 {...{
      "id": "contributors"
    }}>{`Contributors`}</h3>
    <ul>
      <li parentName="ul">{`Austin Edwards`}</li>
      <li parentName="ul">{`Kathryn Gallagher`}</li>
      <li parentName="ul">{`Alexander Meyer`}</li>
      <li parentName="ul">{`Ceci Moralles`}</li>
      <li parentName="ul">{`JP Pollard`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      